import React from "react";
import { ModalServiceContext } from "./../ricos-context/ModalContext.js";
import { createContext, useContextSelector } from "./../_shared/use-context-selector.js";
import { ModalService } from "./ModalService.js";
const ModalStateContext = createContext({});
const ModalProvider = (props) => {
  const [modalState, setModalState] = React.useState({});
  const modalStateRef = React.useRef(modalState);
  modalStateRef.current = modalState;
  const [service] = React.useState(
    () => new ModalService(props.modalSettings ?? {}, {
      get: () => modalStateRef.current ?? {},
      set: setModalState
    })
  );
  return /* @__PURE__ */ React.createElement(ModalServiceContext.Provider, { value: service }, /* @__PURE__ */ React.createElement(ModalStateContext.Provider, { value: modalState }, props.children));
};
const useModalService = () => {
  const context = React.useContext(ModalServiceContext);
  if (!context) {
    throw new Error("useModalService must be used within a ModalProvider");
  }
  return context;
};
const useModalStateContext = ({
  onSelectorContextValue
}) => {
  const context = React.useContext(
    ModalStateContext
  );
  if (!context) {
    throw new Error("useModalStateContext must be used within a ModalProvider");
  }
  onSelectorContextValue(context);
  return context;
};
const useModalState = (selector, trackingString) => {
  return useContextSelector(ModalStateContext, selector, Object.is, trackingString);
};
const getIsModalOpen = (id) => (state) => !!state[id];
const getIsExclusiveModalOpen = (state) => Object.values(state).some((m) => m.type === "exclusive");
export {
  ModalProvider,
  getIsExclusiveModalOpen,
  getIsModalOpen,
  useModalService,
  useModalState,
  useModalStateContext
};
//# sourceMappingURL=modal-service-provider.js.map
